import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { useState } from 'react';

import { useGetBookingForAccountQuery } from '#api/bookingApi.slice.ts';
import ErrorFallback from '#components/shared/ErrorFallback.tsx';
import { hasBookingState } from '#domain/bookingState.ts';
import { Checklist } from '#features/welcome/ui/Checklist.tsx';
import { ContactDialog } from '#features/welcome/ui/ContactDialog.tsx';
import { Intro } from '#features/welcome/ui/Intro.tsx';
import { OnboardingProgress } from '#features/welcome/ui/ProgressBar.tsx';

export const WelcomePage = () => {
    const [showContactDialog, setShowContactDialog] = useState(false);
    const { error, data: bookingData, refetch } = useGetBookingForAccountQuery();

    if (error) {
        return <ErrorFallback onRetry={refetch} />;
    }

    if (!bookingData) {
        return <Spinner />;
    }

    const userHasPendingBooking = hasBookingState(bookingData, 'PENDING');

    return (
        <>
            <div className='container fluid-default display-flex flex-column gap-25'>
                {userHasPendingBooking && <OnboardingProgress />}
                <div className='panel panel-default padding-x-50 padding-top-25 padding-bottom-0 shadow-default'>
                    <div className='display-flex flex-wrap column-gap-50 margin-bottom-50'>
                        <Intro userHasBooked={userHasPendingBooking} setShowContactDialog={setShowContactDialog} />
                        <Checklist userHasBooked={userHasPendingBooking} />
                    </div>
                    <img
                        src='https://rio.cloud/fileadmin/Marketplace/RIO/Products/Order_Communication/General/pocket_driver_compilation.png'
                        alt=''
                        className='max-width-1000 margin-x-auto img-responsive'
                    />
                </div>
            </div>
            <ContactDialog show={showContactDialog} onClose={() => setShowContactDialog(false)} />
        </>
    );
};
